import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of, timer } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CustomPreloadingStrategy implements PreloadingStrategy {
  private preloadedModules: string[] = [];

  preload(route: Route, load: () => Observable<any>): Observable<any> {
    // Check if route has preload data
    if (route.data && route.data['preload']) {
      const delay = route.data['preloadDelay'] || 0;
      const priority = route.data['priority'] || 0;

      //console.log(`Preloading module: ${route.path} with delay: ${delay}ms, priority: ${priority}`);

      return timer(delay).pipe(
        mergeMap(() => {
          this.preloadedModules.push(route.path || '');
          return load();
        })
      );
    }

    return of(null);
  }

  getPreloadedModules(): string[] {
    return [...this.preloadedModules];
  }

  isModulePreloaded(path: string): boolean {
    return this.preloadedModules.includes(path);
  }
}
